<template>
  <div class="page flex-col">
    <div class="group_1 flex-col justify-end">
      <!-- <div class="box_1 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png"
        />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
         <span class="text_2" @click="PageIndex">首页</span>
       <span class="text_3" @click="sdycxq">产品方案</span>
        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div> -->

      <div class="box_1 flex-row items-center"> <!-- 新增items-center确保垂直居中 -->
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
        <!-- <span class="text_3" @click="sdycxq">产品方案</span> -->

        <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="text_3 cursor-pointer">产品方案</span>
          <div class="dropdown-menu" v-if="showDropdown">
            <div class="dropdown-item" @click="handleCaseClick('three_narcotic_drug_vehicle')">三代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('two_narcotic_drug_vehicle')">二代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('consumables_cabinet')">高值耗材柜</div>
            <div class="dropdown-item" @click="handleCaseClick('ai_recycling_bin')">AI智能回收箱</div>
            <div class="dropdown-item" @click="handleCaseClick('hydrogenperoxide_disinfection_machine')">过氧化氢消毒机</div>
            <div class="dropdown-item" @click="handleCaseClick('transfer_bed')">电动转运床</div>

          </div>
        </div>

        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div>

      <div class="box_2 flex-row"><div class="group_2 flex-col"></div></div>
    </div>
    <div class="group_3 flex-row">
      <div class="text-group_1 flex-col justify-between">
        <span class="paragraph_1">
          慧安智远致力于：
          <br />
          让世界上每一支管控药都
          <br />
          数得清、用的清、记得清
          <br />
        </span>
        <span class="text_7">欢迎来到慧安智远，自由随心·Al随行·慧安智远</span>
      </div>
      <div class="box_3 flex-col">
        <div class="image-wrapper_1 flex-col">
          <!-- <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb6c5deffc1f311cdddd63e85d64e542d21b9e228f754e03b5ec3511637a632c6.png"
          /> -->
        </div>
      </div>
      <div class="image-wrapper_2 flex-col">
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cf61ce395c74f98272ed55b67d3e840760e740b739b579e3bf524065a09a976.png"
        />
      </div>
    </div>
    <div class="group_4 flex-col">
      <span class="text_8">我们的案例展示</span>
      <div class="text-group_2 flex-col justify-between">
        <span class="text_9">智能麻精药车+AI智能回收箱+耗材柜落地瑞金医院太仓分院-开启安全用药管理新标杆</span>
        <span class="text_10">
          2025年03月28日，[江苏慧安智远智能医疗科技有限公司]与上海交通大学医学院附属瑞金医院太仓分院圆满完成20余台智能麻精药品管理车及AI智能回收箱和RFID耗材柜的交付仪式。此次合作以“科技赋能医疗安全”为核心，通过智能化设备升级，助力医院实现麻醉精神类药品全流程精准管控，为患者安全用药筑起坚实屏障。
        </span>
      </div>
      <div class="block_1 flex-row justify-between">
        <div class="text-group_3 flex-col justify-between">
          <span class="text_11">创新点·精准守护</span>
          <div class="text-wrapper_1">
            <span class="text_12">本次交付的麻精药车搭载</span>
            <span class="text_13">AI</span>
            <span class="text_14">
              智能识别系统与双指纹加密技术，实现麻精药品存取零误差、操作权限严管控；一体化温湿度监测模块确保特殊药品储存合规，溯源功能
            </span>
            <span class="text_15">3</span>
            <span class="text_16">秒锁定用药全记录，大幅降低临床管理风险，推动医院药事服务迈向数字化、精细化。</span>
            <span class="paragraph_2"><br /></span>
          </div>
        </div>
        <div class="box_4 flex-col"></div>
      </div>
      <div class="block_2 flex-row justify-between">
        <div class="block_3 flex-col"></div>
        <div class="text-group_4 flex-col justify-between">
          <span class="text_17">合作赋能·双向共赢</span>
          <span class="text_18">
            瑞金太仓医院作为长三角区域医疗中心，始终践行“智慧医疗”理念。此次引入智能麻精药车，既是医院提升医疗质量的核心举措，也为[江苏慧安智远]在智慧药管领域的研发实力提供了标杆应用场景。双方通过技术研讨、临床反馈的深度联动，共同探索出更贴合临床需求的解决方案。
          </span>
        </div>
      </div>
      <div class="block_4 flex-row justify-between">
        <div class="text-group_5 flex-col justify-between">
          <span class="text_19">社会责任·长效价值</span>
          <span class="paragraph_3">
            麻醉精神类药品管理是医疗安全的“生命线”。30台设备的规模化落地，预计将为医院每年超10万余台手术的药品安全保驾护航，同时减少人工管理成本约43%，实现社会效益与运营效率的双提升。未来，双方将深化在智慧医院建设领域的战略合作，以科技之力守护医患安全。
            <br />
          </span>
        </div>
        <div class="section_1 flex-col"></div>
      </div>
      <span class="text_20">
        瑞金太仓医院药剂科主任曾表示：“智能化管理工具的引入，标志着我院药事管理正式进入‘秒级响应’时代。”&nbsp;[江苏慧安智远]唐工同步演示了药车应急响应机制，获得院方高度评价。
      </span>
    </div>
    <div class="group_5 flex-col">
      <div class="text-wrapper_2 flex-row">
        <span class="text_21">公司信息</span>
        <span class="text_22">二维码</span>
        <span class="text_23">商务合作</span>
      </div>
      <div class="image-wrapper_3 flex-row justify-between">
        <img
          class="image_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
      </div>
      <div class="group_6 flex-row">
        <span class="paragraph_4">
          江苏慧安智远智能医疗科技有限公司
          <br />
          <br />
          地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
          <br />
          电话：0510-83582015
          <br />
          邮箱：huianzhiyuan&#64;qq.com
          <br />
          官网：www.hilears.com&nbsp;
          <br />
        </span>
        <div class="image-text_1 flex-col justify-between">
          <div class="image-wrapper_4 flex-col">
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png"
            />
          </div>
          <span class="text-group_6">
            关注公众号：HILEARS和尔思
            <br />
          </span>
        </div>
        <span class="text_24">卢先生&nbsp;&nbsp;0510-83582015</span>
      </div>
      <div class="text-wrapper_3 flex-row">
        <span class="text_25">
          Copyright&nbsp;©&nbsp;&nbsp;2025&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有
          <a onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32020602001022')">苏公网安备
            32020602001022号&nbsp;&nbsp;</a>
          <a onclick="window.open('https://beian.miit.gov.cn')">苏ICP备20031743号-1</a>

        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
       // 新增下拉菜单控制变量
      showDropdown: false,
      constants: {}
    };
  },
  methods: {
    // 新增下拉菜单点击处理方法
    handleCaseClick(type) {
      // 根据不同案例类型跳转到不同页面
      this.$router.push(`/${type}`);
      // 关闭下拉菜单
      this.showDropdown = false;
    },
      PageIndex() {
      this.$router.push('/PageIndex')
    },
     sdycxq() {
      this.$router.push('/three_narcotic_drug_vehicle')
    },
    guanyuhuian() {
      this.$router.push('/guanyuhuian')
    },
    case_presentation() {
      this.$router.push('/case_presentation')
    },
    news_information() {
      this.$router.push('/news_information')
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style>
/* 修改下拉菜单样式 */
.dropdown-container {
  position: relative;
  display: inline-flex;
  /* 使用inline-flex保持与其他元素对齐 */
  align-items: center;
  /* 确保文本垂直居中 */
  height: 50%;
  /* 占满父容器高度 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  /* 从容器底部开始显示 */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 5px;
  /* 与主菜单保持一点距离 */
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

/* 调整菜单项样式 */
.dropdown-item {
  padding: 10px 16px;
  color: #1d1f24;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* 修复父容器对齐 */
.box_1 {
  align-items: center;
  /* 确保所有子元素垂直居中 */
  display: flex;
}

/* 保持其他样式不变 */
.text_4 {
  /* 确保文本本身垂直居中 */
  display: inline-flex;
  align-items: center;
  height: 100%;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
